import React from "react";
import {
  FUNDING,
  PayPalScriptProvider,
  PayPalButtons,
} from "@paypal/react-paypal-js";
import { remote } from "ccui-framework";
import { setErrorMessage } from "../action";
import { useDispatch, useSelector } from "react-redux";
import { addDefaultPaymentOption, is } from "../thunk";
import { configSelector } from "ccui-framework";
import { paymentMethods } from "../selector";
import { PAYMENT_TYPES } from "../constant";

const CURRENCY = "USD";
const BUTTON_STYLE = { layout: "vertical" };

// Custom component to wrap the PayPalButtons and handle currency changes
const ButtonWrapper = () => {
  const dispatch = useDispatch();

  return (
    <PayPalButtons
      style={BUTTON_STYLE}
      disabled={false}
      fundingSource={FUNDING.PAYPAL}
      onCancel={() => {}}
      onError={console.error}
      createBillingAgreement={async () => {
        try {
          const paypal = await remote(
            "post",
            `v3/customers/payment-options/paypal/token`,
            "",
            "get paypal billing agreement token",
            dispatch
          );

          if (!"token" in paypal) {
            throw new Error("Token Not Found");
          }

          return paypal.token;
        } catch (e) {
          dispatch(setErrorMessage(e.message));
        }
      }}
      onApprove={async (data) => {
        if (data && "payerID" in data && "billingToken" in data)
          dispatch(
            addDefaultPaymentOption({
              paymentMethod: "PAYPAL_ACCOUNT",
              default: false,
              type: "sell",
              paypalData: { payerId: data.payerID, token: data.billingToken },
            })
          );
      }}
    />
  );
};

const PayPalCheckoutButton = () => {
  const { payPalClientId } = useSelector(configSelector);
  const methods = useSelector((state) => paymentMethods(state));

  if (
    methods.filter((m) =>
      is(m.paymentMethod, PAYMENT_TYPES.PAYPAL_ACCOUNT_BULK)
    ).length
  ) {
    return null;
  }

  return (
    <PayPalScriptProvider
      options={{
        "client-id": payPalClientId,
        components: "buttons",
        currency: CURRENCY,
        vault: true,
        intent: "tokenize",
      }}
    >
      <ButtonWrapper />
    </PayPalScriptProvider>
  );
};

export { PayPalCheckoutButton };
